// extracted by mini-css-extract-plugin
export default {"form":"form_form__4UaWh","title":"form_title__rsLKB"};